module.exports = __webpack_public_path__ + "img/TITLE-04.67674a20.png";